import { CheckIcon, EditIcon } from "@chakra-ui/icons";
import React, { useEffect, useState } from "react";
import BookingDataService from "../../services/Booking";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useToast } from "@chakra-ui/react";
import Select from "react-select";
interface DateTimeFormatOptionsWithTimeZone extends Intl.DateTimeFormatOptions {
  timeZone: string;
  year: "numeric";
  month: "long";
  day: "numeric";
  hour: "numeric";
  minute: "numeric";
  second: "numeric";
}

export const SingleSheetRow = (props: any) => {
  const toast = useToast();
  const { data, experts, dbid } = props;
  const {
    expert_price,
    expert_id,
    payment_description,
    data: {
      created_at,
      id,
      amount,
      order_id,
      amount_refunded,
      vpa,
      email,
      description,
      status,
      fee,
      tax,
      notes,
    },
  } = data;

  const storedcontrols = localStorage.getItem("logged_in_user_accesscontrols");
  const userControls: any[] = storedcontrols ? JSON.parse(storedcontrols) : [];

  const [isEditable, setIsEditable] = useState(false);
  const [isExpertEditable, setIsExpertEditable] = useState(false);
  const [price, setPrice] = useState("");
  const [expertId, setExpertId] = useState(expert_id || "");

  const expertOptions = experts.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const getSourceName = (notes: any, description: any) => {
    let source = "";
    if (notes && notes.length !== 0 && notes.wix_order_id) {
      source = "WIX";
    } else if (splitString(description)[0] === "APP") {
      source = "APP";
    } else {
      source = "other";
    }
    return source;
  };

  function unixTimeToDateTime(unixTime: number) {
    const milliseconds = unixTime * 1000;
    const date = new Date(milliseconds);

    const options: DateTimeFormatOptionsWithTimeZone = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };

    const dateTimeString = date.toLocaleString("en-IN", options);

    const year = date.toLocaleString("en-IN", { year: "numeric" });
    const month = date.toLocaleString("en-IN", { month: "long" });

    return { dateTimeString, year, month };
  }

  const getExpertprice = (description: any, createdAt: any) => {
    const descriptionParts = splitString(description);
    const expert_id = expertId || descriptionParts[6] || "";
    const fullName = expertId
      ? expertOptions.find((option: any) => option.value === expertId)?.label ||
      ""
      : descriptionParts[5] || "";
    // const fullName = descriptionParts[5] || "";
    const sessionType = descriptionParts[1] || "";
    const bookingType = descriptionParts[2] || "";
    // console.log(fullName, sessionType,bookingType);
    const expert = experts.find(
      (el: any) =>
        el.data.full_name.trim().toLowerCase() ===
        fullName.trim().toLowerCase() || el._id === expert_id
    );

    if (!expert) return null;
    else if (expert.data.prices.length < 1) return null;
    else {
      const price = expert.data.prices.find((item: any) => {
        const fromDate = new Date(item.data.fromDate);
        const toDate = item.data.toDate ? new Date(item.data.toDate) : null;
        const createdAtDate = new Date(createdAt * 1000);

        if (!toDate) {
          return createdAtDate >= fromDate;
        } else {
          return createdAtDate >= fromDate && createdAtDate <= toDate;
        }
      });

      if (!price) return null;
      else {
        const priceDetails = price.data;
        const formattedSessionType =
          sessionType === "AUDIO"
            ? "call"
            : sessionType.replace(/_/g, "").toLowerCase();
        const isSessionExists = formattedSessionType in priceDetails;
        if (!isSessionExists) return null;
        else {
          const sessionValues = priceDetails[formattedSessionType];
          const typeMapping: any = {
            SUBSCRIPTION10: "10session",
            SUBSCRIPTION5: "5session",
            SUBSCRIPTION3: "3session",
            SINGLE: "1session",
          };

          const bookingKey = typeMapping[bookingType];

          if (sessionValues.hasOwnProperty(bookingKey)) {
            if (bookingKey === "10session")
              return (Number(sessionValues[bookingKey]) * 10).toString();
            else if (bookingKey === "5session")
              return (Number(sessionValues[bookingKey]) * 5).toString();
            else if (bookingKey === "3session")
              return (Number(sessionValues[bookingKey]) * 3).toString();
            else return sessionValues[bookingKey];
          } else {
            return null;
          }
        }
      }
    }
  };

  function splitString(description: string) {
    return description ? description.split("_") : [];
  }

  function convertInRupee(value: number) {
    const result = value / 100;
    return parseFloat(result.toFixed(2));
  }

  const handleSavePrice = () => {
    BookingDataService.updateExpertPrice(dbid, price)
      .then((res) => {
        setIsEditable(false);
        toast({
          position: "top",
          title: "Expert Price Saved Successfully",
          description: "The expert price has been saved successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          position: "top",
          title: "Expert Price Save Failed",
          description:
            "There was an error saving the expert price. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      });
  };

  const handleSaveExpert = () => {
    BookingDataService.updateExpertId(dbid, expertId)
      .then((res) => {
        setIsExpertEditable(false);
        setPrice(getExpertprice(payment_description || description, created_at));
        toast({
          position: "top",
          title: "Expert Saved Successfully",
          description: "The expert has been saved successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          position: "top",
          title: "Expert Save Failed",
          description:
            "There was an error saving the expert. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      });
  };
  //APP_PERSONAL_SINGLE_SESSION_WITH_SHEFALI BHARDWAJ
  //0    1        2        3     4     5

  useEffect(() => {
    if (expert_price) {
      setPrice(expert_price);
    } else if (getExpertprice(payment_description ||description, created_at)) {
      setPrice(getExpertprice(payment_description || description, created_at));
    } else {
      setPrice("");
    }
  }, []);

  return (
    <tr>
      <td>{unixTimeToDateTime(created_at).year}</td>
      <td>{unixTimeToDateTime(created_at).month}</td>
      <td>{id}</td>
      <td>{convertInRupee(amount)}</td>
      <td>{convertInRupee(fee)}</td>
      <td>{convertInRupee(fee - tax)}</td>
      <td>{convertInRupee(tax)}</td>
      <td>{order_id}</td>
      <td>{convertInRupee(amount_refunded)}</td>
      <td>{vpa}</td>
      <td>{email}</td>
      <td>{unixTimeToDateTime(created_at).dateTimeString}</td>
      <td>{getSourceName(notes, description)}</td>
      <td>{status}</td>
      <td>{splitString(payment_description ||description)[1] || ""}</td>
      {/* <td>{splitString(description)[5] || ""}</td> */}
      <td>
        <Row>
          <Col xs={8}>
            <Select
              id="expert_id"
              name="expert_id"
              value={
                expertOptions.find((option: any) => {
                  const idMatch =
                    option.value ===
                    (expertId || splitString(payment_description || description)[6] || "");
                  const nameMatch =
                    option.label.trim().toLowerCase() ===
                    (splitString(payment_description || description)[5] || "").trim().toLowerCase();
                  return idMatch || nameMatch;
                }) || null
              }
              onChange={(selectedOption) =>
                setExpertId(selectedOption?.value || "")
              }
              options={expertOptions}
              isDisabled={!isExpertEditable}
              placeholder="Choose Expert"
              styles={{
                control: (base) => ({
                  ...base,
                  width: "180px",
                }),
                menu: (base) => ({
                  ...base,
                  width: "180px",
                }),
              }}
              classNamePrefix="custom-select"
            />
            {/* <Form.Select
              value={expertId || splitString(payment_description || description)[6] || ""}
              onChange={(e) => setExpertId(e.target.value)}
              disabled={!isExpertEditable}
              style={{
                width: "160px",
                zIndex: "2",
                backgroundColor: "transparent",
                color: "black",
              }}
              className="custom-select"
            >
              <option value="">Choose Expert</option>
              {expertOptions.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select> */}
          </Col>
          <Col xs={3}>
            {userControls.includes("confirmUserBillingExpert") &&
              (isExpertEditable ? (
                <Button className="sheet_btn" onClick={handleSaveExpert}>
                  <CheckIcon />
                </Button>
              ) : (
                <Button
                  className="sheet_btn"
                  onClick={() => setIsExpertEditable(true)}
                >
                  <EditIcon />
                </Button>
              ))}
          </Col>
        </Row>
      </td>
      {!userControls.includes("hideBillingPayments") && (
        <td>
          <Row>
            <Col xs={8}>
              <Form.Control
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                disabled={!isEditable}
                style={{ width: "120px" }}
              />
            </Col>
            <Col xs={3}>
              {isEditable ? (
                <Button className="sheet_btn" onClick={handleSavePrice}>
                  <CheckIcon />
                </Button>
              ) : (
                <Button
                  className="sheet_btn"
                  onClick={() => setIsEditable(true)}
                >
                  <EditIcon />
                </Button>
              )}
            </Col>
          </Row>
        </td>
      )}
      <td>{splitString(payment_description || description)[2] || ""}</td>
    </tr>
  );
};
